import './style.css';

interface TranslationBubbleProps {
  content: string;
}
const TranslationBubble = (props: TranslationBubbleProps) => {
  const { content } = props;
  return <div className="translation-bubble">{content}</div>;
};

export default TranslationBubble;
